<template>
  <div class="textTip">
    <template v-if="msgObj.btnType == 0">
      <span v-html="msgObj.content"></span>
      <span class="cancel" @click="cancelLineUp">取消</span>
    </template>
    <template v-else-if="msgObj.btnType == 1">
      客服 <span  class="red" v-html="msgObj.content"></span> 为您服务
    </template>
    <template v-else-if="msgObj.btnType == 2">
      目前排队人数较多，需要等待时间较长。您可以<span @click="nativeFeedBack" style="color:#088aff;">点此</span>取消排队并进行留言，我司将尽快与您取得联系！
      <span class="cancel" @click="cancelLineUp">取消</span>
    </template>
    <template v-else>
      <span v-html="msgObj.content"></span>
    </template>
  </div>
</template>

<script>

export default {
  name: 'text-tip',
  props: {
    msgObj: Object
  },
  computed: {
    isStaff () {
      return this.msgObj.content
    }
  },
  methods: {
    cancelLineUp() {
      Bus.$emit("cancelLineUp");
    },
    nativeFeedBack() {
      Bus.$emit("cancelLineUp");
      window.open("http://feedback.1234567.com.cn/");
      // this.$Native.nativeFeedBack();
    }
  }
}
</script>

<style scoped>
.textTip {
  text-align: center;
  font-size: 15px;
  color: #666;
  padding: 10px;
}
.textTip .cancel{
  color: #088aff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/TextTip.vue